module.exports = __webpack_public_path__ + "static/media/game-end.14dc0644.mp3";